import clientLogo from "../../images/clients/Colored/Cakes_Bakes.png"

const cakesAndBakes = {
  pageTitle: "Visiomate - Cakes & Bakes Case Study",
  metaDescription:
    "How Visiomate re-implemented Dynamics 365 for a Cakes & Bakes production facility — manufacturing, inventory and dispatch moved off registers and spreadsheets.",
  clientName: "Cakes & Bakes",
  bannerSummary:
    "Dynamics 365 re-implemented for a production facility of Pakistan's first ISO-certified bakery chain",
  introHeading: "Dynamics 365 Re-implementation for Cakes & Bakes",
  heroImageAlt: "Cakes & Bakes production facility",
  clientLogoSrc: clientLogo,
  about:
    "Cakes & Bakes has been baking for Lahore since 1995 and was the first bakery chain in Pakistan to earn ISO 9001 certification. Today it runs outlets across Punjab, supplied by its own production facilities. One of those facilities was running Dynamics 365, but the system had never been set up to match how the facility actually worked.",

  challengesIntro: "Dynamics 365 was in place, but most of the real work was happening outside it.",
  challenges: [
    {
      title: "Stock on Paper Registers",
      desc: "Inventory issuance and dispatch were written in registers, so the system never showed true stock.",
    },
    {
      title: "Spreadsheets Beside the ERP",
      desc: "Key information lived in sheets that didn't match what Dynamics 365 held.",
    },
    {
      title: "No Manufacturing in the System",
      desc: "Production hadn't been set up in Dynamics 365 at all.",
    },
    {
      title: "Reports They Couldn't Get",
      desc: "Daily, weekly and monthly reporting needs had no report behind them.",
    },
  ],

  solutionsIntro:
    "We started by finding the gaps, then re-implemented Dynamics 365 around the facility's real process.",
  solutions: [
    {
      num: "01",
      text: "Gap Analysis",
      desc: "A full review of the running Dynamics 365 setup against how the facility actually works.",
    },
    {
      num: "02",
      text: "Dynamics 365 Re-implemented",
      desc: "Supply chain and inventory reconfigured so the system matches the process.",
    },
    {
      num: "03",
      text: "Manufacturing, Set Up From Scratch",
      desc: "Production planned and recorded inside Dynamics 365 for the first time.",
    },
    {
      num: "04",
      text: "Issuance and Dispatch in the System",
      desc: "The paper registers retired; every movement recorded in Dynamics 365.",
    },
    {
      num: "05",
      text: "Customisations for the Gaps",
      desc: "Features the standard setup didn't cover, built to fit the facility's way of working.",
    },
    {
      num: "06",
      text: "Daily, Weekly and Monthly Reports",
      desc: "Around 15 reports for the figures management needs on a regular cycle.",
    },
  ],

  resultsIntro: "When we were done, everything the facility ran was in the system.",
  metrics: [
    { metric: "100%", label: "Of inventory issuance and dispatch recorded in Dynamics 365, not registers" },
    { metric: "~15", label: "Reports for daily, weekly and monthly decisions" },
    { metric: "Live", label: "Manufacturing running inside Dynamics 365 for the first time" },
  ],
  outcomes: [
    "One system replaced the registers and side spreadsheets",
    "Production is visible in the same place as stock and dispatch",
    "Management gets its regular figures from the system instead of compiling them by hand",
  ],

  // Both other clients on the manufacturing/distribution industry pages
  // this case study is proof on.
  relatedLinks: [
    {
      to: "/caseStudies/projects/ecoZohm",
      label: "See the EcoZohm manufacturing story",
      note: "Another Odoo manufacturing implementation, live in seven weeks.",
    },
    {
      to: "/caseStudies/projects/borjan",
      label: "Read how Borjan runs its reporting",
      note: "25+ supply chain and finance reports built on Dynamics 365.",
    },
  ],
}

export default cakesAndBakes
